import React from "react";
import Blacklisted from "../../../assets/images/icons/certificate-blacklisted.svg";
import Expired from "../../../assets/images/icons/certificate-expired.svg";
import Impersonation from "../../../assets/images/icons/certificate-impersonation.svg";
import Invalid from "../../../assets/images/icons/certificate-invalid.svg";
import Revoked from "../../../assets/images/icons/certificate-revoked.svg";
import SelfSigned from "../../../assets/images/icons/certificate-self-signed.svg";
import Untrusted from "../../../assets/images/icons/certificate-untrusted.svg";
import Valid from "../../../assets/images/icons/certificate-valid.svg";
import Whitelisted from "../../../assets/images/icons/certificate-whitelisted.svg";
import { convertToShortValidationResult } from "../utils";
import styles from "./certificateIcon.module.scss";
const ShortResultsIcon = ({ results, }) => {
    // Order is important and must be kept!
    if (results.includes("Invalid")) {
        return React.createElement(Invalid, null);
    }
    else if (results.includes("Blacklisted")) {
        return React.createElement(Blacklisted, null);
    }
    else if (results.includes("Impersonation")) {
        return React.createElement(Impersonation, null);
    }
    else if (results.includes("Revoked")) {
        return React.createElement(Revoked, null);
    }
    else if (results.includes("Self-signed")) {
        return React.createElement(SelfSigned, null);
    }
    else if (results.includes("Expired")) {
        return React.createElement(Expired, null);
    }
    else if (results.includes("Untrusted")) {
        return React.createElement(Untrusted, null);
    }
    else if (results.includes("Whitelisted")) {
        return React.createElement(Whitelisted, null);
    }
    else {
        return React.createElement(Valid, null);
    }
};
const CertificateIcon = ({ validationResults, }) => {
    const shortResults = validationResults.map((validationResult) => convertToShortValidationResult(validationResult));
    return (React.createElement("div", { className: styles["certificate-icon"] },
        React.createElement("div", { className: styles.icon },
            React.createElement(ShortResultsIcon, { results: shortResults }))));
};
export default CertificateIcon;
//# sourceMappingURL=CertificateIcon.js.map